module.exports = __webpack_public_path__ + "img/kuang.6ce5bbc6.png";